import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import userEvent from "@testing-library/user-event";

const StockListTableFilter = (props) => {
  const [form] = Form.useForm();

  const [stockSelect, setStockSelect] = useState({
    data: [],
    loading: false,
  });
  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    getStocks();
  }, []);

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const onStockSearch = (value) => {
    if (value.length >= 2) {
      setStockSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Stock?$select=id,stockCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setStockSelect({ data: res.value, loading: false });
      });
    } else {
      setStockSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        conditions.push(`id eq ${values.id}`);
      }

      if (values.stockCode) {
        conditions.push(odata.contains("stockCode", values.stockCode));
      }

      if (values.storageNo) {
        conditions.push(odata.contains("storageNo", values.storageNo));
      }

      if (values.shelfNo) {
        conditions.push(odata.contains("shelfNo", values.shelfNo));
      }

      if (values.palletNo) {
        conditions.push(odata.contains("palletNo", values.palletNo));
      }

      if (values.containerNo) {
        conditions.push(odata.contains("containerNo", values.containerNo));
      }

      if (values.stationNo) {
        conditions.push(odata.contains("stationNo", values.stationNo));
      }
      if (values.transactionProjectTypeId) {
        conditions.push(
          `transactionProjectTypeId eq  ${values.transactionProjectTypeId}`
        );
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const getStocks = () => {
    setStockSelect({
      ...stockSelect,
      loading: false,
    });

    if (props.data.id) {
      RequestHandler.get(`/Stock?$select=id,stockCode,name`).then((res) => {
        setStockSelect({
          data: res.value.filter((x) => x.id == props.data.id),
          loading: false,
        });
      });
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label="Ürün Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onStockSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={stockSelect.loading}
                    >
                      {stockSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.stockCode}
                        >
                          {item.name + " (" + item.stockCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="stockCode" label="Stok Kodu :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="transactionProjectTypeId"
                    label="Ana Depo Adı :"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectSelect.loading}
                    >
                      {projectSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} lg={6}>
                  <Form.Item name="shelfNo" label="Raf No :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="palletNo" label="Palet No :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="containerNo" label="Kap No :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="stationNo" label="İstasyon No :">
                    <Input allowClear />
                  </Form.Item>
                </Col> */}
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default StockListTableFilter;
